import { Button, Result } from "antd";
import PageHeader from "components/PageHeader";
import { CreateForm } from "features/Campaign/components/CampaignForm";
import { CAMPAIGN_TYPE } from "features/Campaign/constants";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import { getQuery } from "utils/helperFuncs";

const CamPaignCreateForm = () => {
  const GET_QUERY = getQuery();
  const history = useHistory();

  const pageTitle = () => {
    switch (GET_QUERY.campaignType) {
      case CAMPAIGN_TYPE.COMBO_PROMO:
        return "Tạo mới khuyến mãi theo combo";
      case CAMPAIGN_TYPE.TOP_SALES:
        return "Tạo mới khuyến mãi đua top";
      case CAMPAIGN_TYPE.PRODUCT_PROMO:
        return "Tạo mới khuyến mãi trên 1 sản phẩm";
      case CAMPAIGN_TYPE.CASH_DISCOUNT:
      case "CASH_DISCOUNT":
        return "Thêm mới chiết khấu tiền mặt";
      case CAMPAIGN_TYPE.ORDER_PROMO:
        return "Thêm mới khuyến mãi cho đơn hàng";
      case CAMPAIGN_TYPE.LUCKY_WHEEL:
        return "Thêm mới vòng quay may mắn";
      default:
        return "#";
    }
  };

  return GET_QUERY.campaignType ? (
    <>
      <PageHeader
        pageTitle={pageTitle()}
        routes={[
          {
            path: "/campaign",
            name: t("campaign.form.list"),
          },
          {
            path: "",
            name: pageTitle(),
          },
        ]}
      />
      <CreateForm />
    </>
  ) : (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={() => history.push("/campaign")}>
          Back về Danh sách khuyến mãi
        </Button>
      }
    />
  );
};

export default CamPaignCreateForm;
